<template>
<v-container v-if="policy" class="pt-0 px-0" fluid>
  <v-tabs v-model="displayedTab" background-color="integrity" dark show-arrows icons-and-text @change="tabChange">
    <v-tab v-for="(tab, tabIndex) in tabConfig" :key="tabIndex" :value="tabIndex + 1">
      {{ tab.title }}
      <v-icon>{{ tab.icon }}</v-icon>
    </v-tab>
  </v-tabs>
  <v-tabs-items v-model="displayedTab">
    <template>
      <v-tab-item v-for="(tab, tabIndex) in tabConfig" :key="tabIndex">
        <v-container>
          <v-row>
            <v-col cols="12" class="pt-0 px-0">
              <component :is="tab.component" v-bind="tab.propsData" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </template>
  </v-tabs-items>
</v-container>
</template>

<style>
</style>

<script>
import { mapActions, mapState } from 'vuex';

import GeneralPolicyInformation from '@/components/Client/Policies/GeneralPolicyInformation.vue';
import LinesOfBusinessWrapper from '@/components/Client/Policies/LinesOfBusinessWrapper.vue';
import PolicyCoverages from '@/components/Client/Policies/PolicyCoverages.vue';
import LineOfBusinessCoverages from '@/components/Client/LineOfBusiness/LineOfBusinessCoverages.vue';
import Vehicles from '@/components/Client/LineOfBusiness/Vehicles/Vehicles.vue';
import Drivers from '@/components/Client/LineOfBusiness/Drivers/Drivers.vue';
import Hazards from '@/components/Client/LineOfBusiness/Hazards/Hazards.vue';
import Schedules from '@/components/Client/LineOfBusiness/Schedules/Schedules.vue';
import HomeUnderwriting from '@/components/Client/Policies/Home/HomeUnderwriting.vue';
import HomeCoverages from '@/components/Client/Policies/Home/HomeCoverages.vue';
import MoProCoverages from '@/components/Client/Policies/MoPro/MoProCoverages.vue';
import analyticsService from '@/services/shared/analyticsService.js';
import lobCodeService from '@/services/clientViewer/lobCodeService.js';

export default {
  name: 'PolicyDetailTabs',
  components: {
    GeneralPolicyInformation,
    LinesOfBusinessWrapper,
    PolicyCoverages,

    LineOfBusinessCoverages,
    Vehicles,
    Drivers,
    Hazards,
    Schedules,
    HomeUnderwriting,
    HomeCoverages,
    MoProCoverages
  },
  props: {
    policy: {
      required: true,
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      generalPolicyType: 71,
      moProPolicyType: 77
    };
  },
  computed: {
    ...mapState(['activePolicyTab']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    displayedTab: {
      get: function () {
        return this.activePolicyTab;
      },
      set: function (val) {
        this.setActivePolicyTab(val);
      }
    },
    isAPackage: function () {
      return (this.policy || null) === null
        ? false
        : ((this.policy.linesOfBusiness || null) !== null && this.policy.linesOfBusiness.length > 1);
    },
    isGeneralPolicyType: function () {
      return (this.policy || null) !== null && this.policy.type === this.generalPolicyType;
    },
    isMoProPolicyType: function () {
      return (this.policy || null) !== null && this.policy.type === this.moProPolicyType;
    },
    tabConfig: function () {
      var tabs = [
        {
          title: 'Info',
          icon: 'mdi-information-outline',
          component: 'GeneralPolicyInformation',
          propsData: { policy: this.policy },
          gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Policy Info Tab' }
        }
      ];

      if (this.isGeneralPolicyType) {
        if (this.isAPackage) {
          this.addPackageTabs(tabs);
        } else {
          if (this.policy.linesOfBusiness == null || this.policy.linesOfBusiness[0] == null) {
            return tabs;
          }

          tabs.push({
            title: 'Coverages',
            icon: 'mdi-shield-outline',
            component: 'PolicyCoverages',
            propsData: { policy: this.policy },
            gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Policy Coverages Tab' }
          });

          var lob = this.policy.linesOfBusiness[0];
          if (lobCodeService.containsHazards(lob.code)) {
            this.addHazardTab(tabs);
          } else if (lobCodeService.containsSchedules(parseInt(lob.code))) {
            this.addScheduleTabs(tabs);
          }
        }
      } else if (this.isMoProPolicyType) {
        tabs.push({
          title: 'Coverages',
          icon: 'mdi-shield-half-full',
          component: 'MoProCoverages',
          gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'MoPro Coverages Tab' }
        });
      } else {
        if (this.policy.linesOfBusiness == null || this.policy.linesOfBusiness[0] == null) {
          return tabs;
        }

        switch (this.policy.type) {
          case 65: // Auto
            tabs.push({
              title: 'Fees',
              icon: 'mdi-cash',
              component: 'PolicyCoverages',
              propsData: { isVehicle: true },
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Auto Fees Tab' }
            });

            tabs.push({
              title: 'Drivers',
              icon: 'mdi-account-multiple',
              component: 'Drivers',
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Auto Drivers Tab' }
            });

            tabs.push({
              title: 'Vehicles',
              icon: 'mdi-car',
              component: 'Vehicles',
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Auto Vehicles Tab' }
            });
            break;
          case 66: // Boat
            tabs.push({
              title: 'Fees',
              icon: 'mdi-cash',
              component: 'PolicyCoverages',
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Boat Fees Tab' }
            });

            tabs.push({
              title: 'Operators',
              icon: 'mdi-ship-wheel',
              component: 'Drivers',
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Boat Operators Tab' }
            });

            tabs.push({
              title: 'Boats',
              icon: 'mdi-anchor',
              component: 'Vehicles',
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Boat Boats Tab' }
            });
            break;
          case 72: // Home
            tabs.push({
              title: 'Coverages',
              icon: 'mdi-shield-half-full',
              component: 'HomeCoverages',
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Home Coverages Tab' }
            });

            tabs.push({
              title: 'Home',
              icon: 'mdi-home-outline',
              component: 'HomeUnderwriting',
              gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Home Underwriting Tab' }
            });
            break;
          default:
            break;
        }
      }

      return tabs;
    }
  },
  methods: {
    ...mapActions(['setActivePolicyTab']),
    tabChange: function (value) {
      var tab = this.tabConfig[value];
      if ((tab || null) !== null) {
        analyticsService.sendEvent(this.$gtag, tab.gtagConfig.action, tab.gtagConfig.category, tab.gtagConfig.label);
      }
    },
    shouldDisplayHazards: function (lobCode) {
      return lobCodeService.containsHazards(lobCode);
    },
    addPackageTabs: function (tabs) {
      tabs.push({
        title: 'Lines of Bus.',
        icon: 'mdi-clipboard-text-multiple-outline',
        component: 'LinesOfBusinessWrapper',
        propsData: { policy: this.policy },
        gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'View Lines Of Business' }
      });

      tabs.push({
        title: 'Coverages',
        icon: 'mdi-shield-outline',
        component: 'PolicyCoverages',
        propsData: { policy: this.policy },
        gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'View Pkge covs' }
      });
    },
    addHazardTab: function (tabs, lobCode) {
      tabs.push({
        title: 'Hazards',
        icon: 'mdi-hazard-lights',
        component: 'Hazards',
        gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: lobCodeService.containsWorkHazards(parseInt(lobCode)) ? 'Work Hazards Tab' : 'GL Hazards Tab' }
      });
    },
    addScheduleTabs: function (tabs) {
      tabs.push({
        title: 'Scheduled',
        icon: 'mdi-format-list-numbered',
        component: 'Schedules',
        propsData: { scheduleType: 1 },
        gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Policy Scheduled Property' }
      });

      tabs.push({
        title: 'Unscheduled',
        icon: 'mdi-format-list-bulleted',
        component: 'Schedules',
        propsData: { scheduleType: 2 },
        gtagConfig: { action: 'Tab Navigation', category: 'Policy', label: 'Policy Unscheduled Property' }
      });
    }
  }
};
</script>
